/** Returns MUI color token based on coverage rate thresholds */
export function coverageColor(rate: number): 'success' | 'warning' | 'error' {
  if (rate >= 70) return 'success';
  if (rate >= 40) return 'warning';
  return 'error';
}
